var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("GuidedTourHost", {
    attrs: {
      ativo: _vm.ativo,
      passos: _vm.passos,
      indice: _vm.indice,
      fase: _vm.fase,
      "proxima-etapa": _vm.proximaEtapa,
      marcando: _vm.marcando,
      "marcar-concluida": _vm.marcarConcluida,
      "reancorar-token": _vm.reancorarToken,
      "drawer-aberto": _vm.drawerAberto
    },
    on: {
      avancar: _vm.avancar,
      voltar: _vm.voltar,
      fechar: _vm.fechar,
      "alternar-drawer": _vm.alternarDrawer,
      "proxima-etapa": _vm.irParaProximaEtapa,
      "update:marcarConcluida": _vm.definirMarcacao
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }